const paths = {
	landing        : '/',
	login          : '/login',
	profile        : '/profile',
	jclass         : '/jclass',
	apply          : '/apply/application_form',
	resetPassword  : '/reset_password',
	interview      : '/interview',
	zoom           : '/zoom',
	forgotPassword : '/forgot',
	onlineSession  : '/onlineSession',
	exam           : '/exam',
	onboarding     : '/onboarding',
	auth           : '/auth',
	tos            : "https://fastoffer.co.jp/terms-of-use-privacy-policy-",
	tosJclass      : "https://fastoffer.co.jp/terms-of-use-privacy-policy-jp-class-"
};

export default paths;
